import { api } from "./api";
import { ExamQuestion } from "@/types/ExamQuestion";

interface ApiResponse {
    req: {
        page: string;
        limit: string;
        search: string;
        type: string
    };
    data: ExamQuestion[];
    total: number;
    currentPage: number;
    totalPages: number;
}

export const examQuestionService = {
    async getExamQuestions(req: { page: number; pageSize: number, type: string }): Promise<ApiResponse> {
        const response = await api.get('exam-questions', {
            params: {
                page: req.page,
                limit: req.pageSize,
                type: req.type
            }
        });
        return response.data;
    },

    async getPrivateExamQuestions(req: { page: number; pageSize: number }): Promise<ApiResponse> {
        const response = await api.get('exam-questions/private', {
            params: {
                page: req.page,
                limit: req.pageSize,
            }
        });
        return response.data;
    },

    async findExamQuestionById(id: string): Promise<ExamQuestion> {
        const response = await api.get(`exam-questions/${id}`);
        return response.data;
    },

    async deleteExamQuestion(examId: string): Promise<void> {
        await api.delete(`exam-questions/${examId}`);
    },

    async createExamQuestion(exam: Omit<ExamQuestion, 'id'>): Promise<void> {
        await api.post('exam-questions', exam);
    },

    async updateExamQuestion(exam: ExamQuestion): Promise<void> {
        await api.put(`exam-questions/${exam.id}`, exam);
    }
};
